import { useQuery, useQueryClient } from "@tanstack/react-query";
import { UserPlus, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const useFollowBack = () => {
  const qc = useQueryClient();
  return async (id, name) => {
    try {
      await api.followBack(id);
      toast.success(`You now follow ${name.split(" ")[0]}`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not follow back");
    }
    ["followers", "friends", "notifications"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  };
};

export const useFollowers = () => useQuery({ queryKey: ["followers"], queryFn: api.followers, refetchInterval: 60000 });

export const FollowersStrip = () => {
  const { data: followers = [] } = useFollowers();
  const followBack = useFollowBack();
  const pending = followers.filter((f) => !f.following_back);
  if (!pending.length) return null;
  return (
    <div className="w-full rounded-xl border border-sky-400/20 bg-sky-400/[0.05] px-4 py-3" data-testid="followers-strip">
      <p className="eyebrow !text-sky-300/80 mb-2">Following you</p>
      <div className="flex flex-wrap gap-2">
        {pending.map((f) => (
          <div key={f.user_id} className="flex items-center gap-2 pl-3 pr-1 py-1 rounded-full border border-white/10 text-sm" data-testid={`follower-${f.user_id}`}>
            {f.name}
            <button onClick={() => followBack(f.user_id, f.name)} data-testid={`follow-back-${f.user_id}`}
              className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-sky-400 text-[#06121c] text-xs font-medium hover:bg-sky-300 transition-colors">
              <UserPlus size={12} /> Follow back
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export const FollowBackInline = ({ actor }) => {
  const { data: followers = [] } = useFollowers();
  const followBack = useFollowBack();
  const f = followers.find((x) => x.user_id === actor.user_id);
  if (!f) return null;
  if (f.following_back) return <span className="flex items-center gap-1 text-[11px] text-emerald-300"><Check size={11} /> Following</span>;
  return (
    <button onClick={() => followBack(actor.user_id, actor.name)} data-testid={`notif-follow-back-${actor.user_id}`}
      className="mt-1.5 flex items-center gap-1 px-2.5 py-1 rounded-full bg-sky-400 text-[#06121c] text-[11px] font-medium hover:bg-sky-300 transition-colors">
      <UserPlus size={11} /> Follow back
    </button>
  );
};
